import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AuthProvider from "./Pages/context/AuthProvider/AuthProvider";
import Home from "./Pages/Home/Home/Home";
import Login from "./Pages/Login/Login/Login";
import Register from "./Pages/Login/Register/Register";
import ProductDetails from "./Pages/Details/ProductDetails/ProductDetails";
import PrivateRoute from "./Pages/PrivateRoute/PrivateRoute";
import Order from "./Pages/Order/Order";
import DashboardPort from "./Pages/Dashboard/DashboardPort/DashboardPort";
import Dashboard from "./Pages/Dashboard/Dashboard/Dashboard";
import Payment from "./Pages/Dashboard/Payment/Payment";
import MakeAdmin from "./Pages/Dashboard/Admin/MakeAdmin/MakeAdmin";
import MyOrder from "./Pages/Dashboard/MyOrder/MyOrder";
import ManageProducts from "./Pages/Dashboard/Admin/ManageProducts/ManageProducts";
import AddACake from "./Pages/Dashboard/Admin/AddACake/AddACake";
import ManageAllOrder from "./Pages/Dashboard/Admin/ManageAllOrder/ManageAllOrder";
import Shops from "./Pages/Shop/Shops/Shops";
import About from "./Pages/About/About/About";
import Blog from "./Pages/Blog/Blog";
import ContactUs from "./Pages/Pages/ContactUs";
import WhatWeDo from "./Pages/Pages/WhatWeDo";
import OurTeam from "./Pages/Pages/OurTeam";
import OurProcess from "./Pages/Pages/OurProcess";
import Cart from "./Pages/Pages/Cart";
function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/contact" element={<ContactUs />} />
         
            <Route path="/whatwedo" element={<WhatWeDo />} />
            <Route path="/ourTeam" element={<OurTeam />} />
            <Route path="/ourProcess" element={<OurProcess />} />
      

            <Route path="/order/:id" element={<Order />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/shop" element={<Shops />} />
            <Route path="/cart" element={<Cart/>} />
            {/* about */}
            <Route path="/about" element={<About />} />
            <Route path="/blogs" element={<Blog />} />
            <Route
              path="/homeProducts/:id"
              element={
                <PrivateRoute>
                  <ProductDetails />
                </PrivateRoute>
              }
            />
            {/* dashboard */}
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  {" "}
                  <Dashboard></Dashboard>
                </PrivateRoute>
              }
            >
              <Route
                path="/dashboard"
                element={<DashboardPort></DashboardPort>}
              ></Route>
              <Route
                path="/dashboard/myOrder"
                element={<MyOrder></MyOrder>}
              ></Route>
              <Route
                path="/dashboard/payment"
                element={<Payment></Payment>}
              ></Route>
              {/* <Route
                path="/dashboard/review"
                element={<Reviews></Reviews>}
              ></Route> */}
              {/* admin */}
              <Route
                path={`/dashboard/makeAdmin`}
                element={<MakeAdmin></MakeAdmin>}
              ></Route>
              <Route
                path={`/dashboard/allProducts`}
                element={<ManageProducts></ManageProducts>}
              ></Route>
              <Route
                path={`/dashboard/addCake`}
                element={<AddACake></AddACake>}
              ></Route>
              <Route
                path={`/dashboard/allOrder`}
                element={<ManageAllOrder></ManageAllOrder>}
              ></Route>
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
export default App;
